import React from "react";
import { Link } from "react-router-dom";
import CatalogueCTA from "../../app/common/elements/CatalogueCTA";
import CustomHeader from "../../app/common/elements/CustomHeader";
import Fade from "react-reveal/Fade";

export default function LegalPage() {
    return (
        <div className="bg-lk_grey_background_dark">
            <CustomHeader
                image="/images/homeBannerBg.jpg"
                heading="Legal"
                breadcrumbs={[
                    { name: "Home", href: "/", count: 1 },
                    { name: "Legal", href: "/legal", count: 2 },
                ]}
            />

            <div className="lg:flex bg-lk_grey_background_light align-middle load_in">
                <Fade left >                
                    
                    <div className="max-w-4xl mx-auto px-6 py-10 bg-white shadow-lg rounded-lg">
                        <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
                        <p className="text-sm mb-6">
                        <span>Effective Date:</span><span className="text-gray-500"> 13 May 2025</span><br/>
                        <span>Last Updated:</span><span className="text-gray-500"> 13 May 2025</span>
                        </p>

                        <p className="mb-6">
                        <strong>Lakato (Pty) Ltd</strong> is committed to protecting your privacy.
                        This Privacy Policy outlines how we collect, use, disclose, and protect your personal
                        information when you use our website <strong>orders.lakato.co.za</strong> and/or our
                        mobile application <strong>“LAKATO”</strong> available on the Apple App Store and
                        Google Play Store.
                        </p>

                        <p className="mb-6">
                        The website and mobile App is designed for use by businesses and their authorized
                        users (customers, employees, or representatives). By accepting and using our services,
                        you agree to the terms of this Privacy Policy.
                        </p>

                        <hr className="my-6"/>

                        <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
                        <h3 className="text-md font-semibold mb-4">We collect several types of information to provide and improve our Services:</h3>

                        <p className="font-semibold mb-2">a. Personal Information</p>
                        <ul className="list-disc list-inside ml-4 mb-4">
                        <li>Company name, industry, registration number</li>
                        <li>Email address</li>
                        <li>Phone number</li>
                        <li>Account credentials</li>
                        <li>Payment information (if applicable)</li>
                        </ul>

                        <p className="font-semibold mb-2">b. Device and Usage Data</p>
                        <p className="ml-4 mb-2">Automatically collected data such as:</p>
                        <ul className="list-disc list-inside ml-8 mb-4">
                        <li>Device type, operating system, and browser type</li>
                        <li>IP address</li>
                        <li>Device information (model, OS version, unique identifiers)</li>
                        <li>Log data and diagnostic information</li>
                        </ul>

                        <p className="font-semibold mb-2">c. Location Data (if applicable)</p>
                        <p className="ml-4 mb-4">
                        If you enable location services, we may collect your geolocation to offer location-based features.
                        </p>

                        <p className="font-semibold mb-2">d. Cookies and Tracking Technologies</p>
                        <p className="ml-4 mb-6">
                        We use cookies and similar technologies on our website and app to enhance your user experience and
                        gather analytics data. You can control cookies through your browser or device settings.
                        </p>

                        <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
                        <h3 className="text-md font-semibold mb-4">We may use your information to:</h3>
                        <ul className="list-disc list-inside ml-4 mb-6">
                        <li>Operate and maintain the website and app</li>
                        <li>Facilitate communication between businesses and their customers</li>
                        <li>Maintain and improve app functionality and user experience</li>
                        <li>Personalize content and user interactions</li>
                        <li>Provide customer support</li>
                        <li>Send transactional and service-related notifications</li>
                        <li>Ensure compliance with legal obligations</li>
                        </ul>

                        <h2 className="text-2xl font-semibold mb-4">3. Sharing Your Information</h2>
                        <h3 className="text-md font-semibold mb-4">We do not sell your data. We may share data in the following circumstances:</h3>
                        <ul className="list-disc list-inside ml-4 mb-6">
                        <li><strong>Service Providers:</strong> With trusted third-party vendors for services such as cloud hosting, analytics, and customer support.</li>
                        <li><strong>Legal Compliance:</strong> When required by law, regulation, or legal process.</li>
                        <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or asset sale.</li>
                        </ul>

                        <h2 className="text-2xl font-semibold mb-4">4. User Rights and Choices</h2>
                        <h3 className="text-md font-semibold mb-4">Depending on your location, you may have the right to:</h3>
                        <ul className="list-disc list-inside ml-4 mb-4">
                        <li>Access and review your personal data</li>
                        <li>Correct inaccuracies</li>
                        <li>Request deletion (subject to contractual obligations)</li>
                        <li>Object to certain processing activities</li>
                        </ul>
                        <p className="ml-4 mb-6">
                        Please contact us at <a href="mailto:support@lakato.co.za" className="text-blue-600 underline">support@lakato.co.za</a>
                        for any requests or inquiries regarding your data.
                        </p>

                        <h2 className="text-2xl font-semibold mb-4">5. Data Security</h2>
                        <p className="ml-4 mb-6">
                        We implement appropriate technical and organizational measures to protect your information.
                        These include encryption, secure storage, access controls, and regular security audits.
                        </p>

                        <h2 className="text-2xl font-semibold mb-4">6. Children’s Privacy</h2>
                        <p className="ml-4 mb-6">
                        Our Services are not directed to children under 18 years of age. We do not knowingly collect
                        personal information from children.
                        </p>

                        <h2 className="text-2xl font-semibold mb-4">7. Third-Party Links and Services</h2>
                        <p className="ml-4 mb-6">
                        Our Services may contain links to third-party websites or services. We are not responsible for
                        their content or privacy practices. Please review their privacy policies.
                        </p>

                        <h2 className="text-2xl font-semibold mb-4">8. Data Retention</h2>
                        <p className="ml-4 mb-6">
                        We retain personal data only as long as necessary to fulfil the purposes outlined in this policy,
                        unless a longer retention period is required by law.
                        </p>

                        <h2 className="text-2xl font-semibold mb-4">9. International Users</h2>
                        <p className="ml-4 mb-6">
                        If you are accessing the website and/or App from outside South Africa, your data may be transferred
                        to and processed in countries with different data protection laws. We ensure appropriate safeguards
                        are in place.
                        </p>

                        <h2 className="text-2xl font-semibold mb-4">10. Changes to This Privacy Policy</h2>
                        <p className="ml-4 mb-6">
                        We may update this Privacy Policy from time to time. When we do, we will update the “Last Updated”
                        date. If the changes are significant, we may notify you via email or in-app notification.
                        </p>

                        <h2 className="text-2xl font-semibold mb-4">11. Contact Us</h2>
                        <h3 className="text-md font-semibold mb-4">If you have questions or concerns about this Privacy Policy, contact us at:</h3>
                        <p className="ml-4">
                        <strong>Lakato (Pty) LTD</strong><br/>
                        Email: <a href="mailto:support@lakato.co.za" className="text-blue-600 underline">support@lakato.co.za</a><br/>
                        Address: Unit 10, Drosté Industrial Park, Benrose, Johannesburg, 2094
                        </p>
                    </div>
                </Fade>
            </div>

            <CatalogueCTA />
        </div>
    );
}
